import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/first_img.jpg';
const _withScopeId = n => (_pushScopeId("data-v-5408b3bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "payment"
};
const _hoisted_2 = {
  class: "steps px-16 py-0.5 bg-white my-2"
};
import { useStore } from '@/stores/pinia';
import Step1 from './Step1.vue';
import Step2 from './Step2.vue';
import Step3 from './Step3.vue';
import { onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const closeFirstImg = () => {
      if (!store.showFirstImg) return;
      store.showFirstImg = false;
      setTimeout(() => store.hasFirstImg = false, 1500);
    };
    onMounted(() => {
      setTimeout(() => {
        closeFirstImg();
      }, 1500);
    });
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_step = _resolveComponent("van-step");
      const _component_van_steps = _resolveComponent("van-steps");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(store).hasFirstImg ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: _normalizeClass(['first-img safe-view', !_unref(store).showFirstImg && 'hide']),
        src: _imports_0,
        alt: "",
        onClick: closeFirstImg
      }, null, 2)) : _createCommentVNode("", true), _createVNode(_component_van_nav_bar, {
        "left-arrow": _unref(store).active === 2,
        title: "汇款信息",
        onClickLeft: _cache[0] || (_cache[0] = $event => _unref(store).active = 1)
      }, null, 8, ["left-arrow"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_steps, {
        active: _unref(store).active,
        "active-color": "#EE0A24"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_step, null, {
          default: _withCtx(() => [_createTextVNode("功德事项")]),
          _: 1
        }), _createVNode(_component_van_step, null, {
          default: _withCtx(() => [_createTextVNode("确认订单")]),
          _: 1
        }), _createVNode(_component_van_step, null, {
          default: _withCtx(() => [_createTextVNode("支付成功")]),
          _: 1
        })]),
        _: 1
      }, 8, ["active"])]), _unref(store).active === 0 ? (_openBlock(), _createBlock(Step1, {
        key: 1
      })) : _createCommentVNode("", true), _unref(store).active === 1 ? (_openBlock(), _createBlock(Step2, {
        key: 2
      })) : _createCommentVNode("", true), _unref(store).active === 2 ? (_openBlock(), _createBlock(Step3, {
        key: 3
      })) : _createCommentVNode("", true)]);
    };
  }
});